import { isNodeList } from "./isNodeList.js";

export function setAttrs(els, attrs) {
  els = (isNodeList(els) || els instanceof Array) ? els : [els];
  if (Object.prototype.toString.call(attrs) !== '[object Object]') { return; }

  for (var i = els.length; i--;) {
    for(var key in attrs) {
      els[i].setAttribute(key, attrs[key]);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/setAttrs.js
// module id = 858
// module chunks = 2